import storeConfig from 'Admin/Store/storeConfig'
import calendarQuickEdit from './CalendarQuickEditSlice'

const reducers = { calendarQuickEdit }
const store = storeConfig({ reducers })
export default store
